export default {
  ACADEMIC_YEAR_WHITELIST: ['2223','2324','2425'],
  YEAR_PREFIX: '20',
  DASHBAORD_HEADER_ID: 'home',
  DASHBOARD_HEADER_DISPLAY: 'Home',
  OPTIONS_HEADER_ID: 'options',
  OPTIONS_HEADER_DISPLAY: 'Options Setup',
  AUDIT_HEADER_ID: 'audit',
  AUDIT_HEADER_DISPLAY: 'Audit History',
  AUDIT_MIDDLE_INSERT: 'of',
  AUDIT_NODATA_MSG: 'No data is available at this time for the Audit History of ',
  NO_DATA_MSG: 'No data is available at this time.',
  API_SERVER_ERROR: 'An unexpected error has occurred. Please wait a few moments before trying again.',
  MANAGE_HEADER_ID: 'manage',
  MANAGE_HEADER_DISPLAY: 'Manage',
  NAO_ROLE_ID: '804',
  NAO_APP_ID: '390',
  ANNOUNCE_TYPE: 'announcement',
  GETYEARSTYPES_SERVICE_ID: 'GETYEARSTYPES',
  GETCONTENTS_SERVICE_ID: 'GETCONTENTS',
  GETOPTIONS_SERVICE_ID: 'GETOPTIONS',
  SAVEOPTIONS_SERVICE_ID: 'SAVEOPTIONS',
  COPYOPTIONS_SERVICE_ID: 'COPYOPTIONS',
  UPDATEDESC_SERVICE_ID: 'UPDATEDESC',
  GETCLIENTS_SERVICE_ID: 'GETCLIENTS',
  GETAUDITS_SERVICE_ID: 'GETAUDITS',
  GETTERMS_SERVICE_ID: 'GETTERMS',
  SAVETERMS_SERVICE_ID: 'SAVETERMS',
  DELETEOPTIONSET_SERVICE_ID: 'DELETEOPTIONSET',
  TIMESTR_MIDDLE_INSERT: 'at',
  CUTOFF_ACADEMICYEAR: '2122',
  LATEST_ACADEMICYEAR: 2425,
  PREFIX_SAVEON_TIME: 'Last Saved on',
  PREFIX_TIMESTAMP: 'Created on',
  COMPARE: 'compare',
};
